<div id="pt_quick_sidebar_toggle" class="topbar-item" style="height: 100%">
	<button [class]="customStyle" (click)="reportBug()">
		<div>
			<i class="fas fa-bug"></i>
		</div>
	</button>
</div>
